import { httpsCallable } from "firebase/functions";
import { functions } from '../../firebase.config';
import { fetchValidUSPSToken } from './fetchValidUSPSToken';
import { calculatePackageDimensions } from './calculatePackageDimensions';

const createIntlShippingLabel = async (cartItems, shippingAddress) => {
    const getUSPSPaymentToken = httpsCallable(functions, 'getUSPSPaymentToken');
    const dimensions = await calculatePackageDimensions(cartItems);

    const weightInOunces = cartItems.reduce((acc, item) => acc + (item.weight * item.quantity), 0);
    const weightInPounds = weightInOunces / 16;

    const parseFullName = (fullName) => {
        if (!fullName) return { firstName: "", lastName: "" };
        const parts = fullName.trim().split(" ");
        return {
            firstName: parts[0],
            lastName: parts.slice(1).join(" ") || parts[0]
        };
    };
    
    const sellerAddress = {
        "firstName": process.env.REACT_APP_SELLER_FIRSTNAME,
        "lastName": process.env.REACT_APP_SELLER_LASTNAME,
        "streetAddress": process.env.REACT_APP_SELLER_STREET_ADDRESS,
        "city": process.env.REACT_APP_SELLER_CITY,
        "state": process.env.REACT_APP_SELLER_STATE,
        "ZIPCode": process.env.REACT_APP_SELLER_ZIP_CODE
    }
    const { firstName, lastName } = parseFullName(shippingAddress.fullName);

    try {
        const tokenResponse = await getUSPSPaymentToken();
        const accessToken = await fetchValidUSPSToken();
        const paymentToken = tokenResponse?.data.data;
            
        // Request USPS label
        const response = await fetch(process.env.REACT_APP_INTERNATIONAL_SHIPPING_LABEL_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                toAddress: {
                    firstName,
                    lastName,
                    phone: shippingAddress.phone,
                    streetAddress: shippingAddress.street,
                    city: shippingAddress.city,
                    province: shippingAddress.state,
                    country: shippingAddress.countryISOAlpha2Code,
                    countryISOAlpha2Code: shippingAddress.country,
                    postalCode: shippingAddress.zip,
                },
                fromAddress: sellerAddress,
                packageDescription: {
                    mailClass: "FIRST-CLASS_PACKAGE_INTERNATIONAL_SERVICE",
                    rateIndicator: "SP",
                    weightUOM: "lb",
                    weight: weightInPounds,
                    dimensionsUOM: "in",
                    length: dimensions.length,
                    height: dimensions.height,
                    width: dimensions.width,
                    processingCategory: "MACHINABLE",
                    mailingDate: new Date().toISOString().split("T")[0],
                    extraServices: [],
                    destinationEntryFacilityType: "NONE",
                },
                customsForm: {
                    customsContentType: "MERCHANDISE",
                    contents: cartItems.map((item) => ({
                        itemDescription: item.productName,
                        itemQuantity: item.quantity,
                        countryofOrigin: "US",
                    })),
                    AESITN: "NOEEI 30.37(a)"
                },
                imageInfo: {
                    imageType: "PDF",
                    labelType: "4X6LABEL",
                    receiptOption: "NONE",
                },
                accessToken,
                paymentToken,
            }),
        });
    
        const rawText = await response.text(); // read once      
        let data;
        try {
            data = JSON.parse(rawText); // try parsing manually
        } catch (e) {
            return null;
        }
            
        if (data.labelImage) {
            return data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
};

export default createIntlShippingLabel;